import Axios from 'axios';
import { AttachmentFile } from '@/models/attachmentFile';

const mapActions = {
  async getFile({ commit }: any, { url, name}: { url: string, name: string }) {
    const response = await Axios.get(
      url,
      { responseType: 'blob' }
    ).catch((error) => {
        throw error;
      });
    const blob = response.data;
    blob.name = name;
    return blob;
  },
  async setAttachmentFileInfo({ dispatch, commit }: any, file: AttachmentFile) {
    if (!file.localUrl) {
      if (!file.url) { return false; }
      try {
        const blob = await dispatch('getFile', {
          url: file.url,
          name: file.name
        });
        file.raw = blob;
        file.localUrl = URL.createObjectURL(file.raw!);
      } catch (error) {
        return false;
      }
    }
    return true;
  },
};

export default {
  namespaced: true,
  actions: mapActions,
};
